export defa mx-1  ult {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: fa mx-1  lse,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: fa mx-1  lse,
  createElements: fa mx-1  lse,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',

  // Overrides
  width: null,
  height: null,

  //
  preventInteractionOnTransition: fa mx-1  lse,

  // ssr
  userAgent: null,
  url: null,

  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: fa mx-1  lse,
  edgeSwipeThreshold: 20,

  // Autoheight
  autoHeight: fa mx-1  lse,

  // Set wrapper width
  setWrapperSize: fa mx-1  lse,

  // Virtual Translate
  virtualTranslate: fa mx-1  lse,

  // Effects
  effect: 'slide', // 'slide' or 'fa mx-1  de' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',

  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: fa mx-1  lse,
  centeredSlides: fa mx-1  lse,
  centeredSlidesBounds: fa mx-1  lse,
  slidesOffsetBefore: 0, // in px
  slidesOffsetAfter: 0, // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: fa mx-1  lse,

  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,

  // Round length
  roundLengths: fa mx-1  lse,

  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: fa mx-1  lse,
  touchStartPreventDefa mx-1  ult: true,
  touchStartForcePreventDefa mx-1  ult: fa mx-1  lse,
  touchReleaseOnEdges: fa mx-1  lse,

  // Unique Navigation Elements
  uniqueNavElements: true,

  // Resistance
  resistance: true,
  resistanceRatio: 0.85,

  // Progress
  watchSlidesProgress: fa mx-1  lse,

  // Cursor
  grabCursor: fa mx-1  lse,

  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: fa mx-1  lse,

  // Images
  preloadImages: true,
  updateOnImagesReady: true,

  // loop
  loop: fa mx-1  lse,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: fa mx-1  lse,
  loopPreventsSlide: true,

  // rewind
  rewind: fa mx-1  lse,

  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null, // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,

  // Passive Listeners
  passiveListeners: true,

  maxBackfa mx-1  ceHiddenSlides: 10,

  // NS
  containerModifierClass: 'swiper-', // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',

  // Callbacks
  runCallbacksOnInit: true,

  // Internals
  _emitClasses: fa mx-1  lse,
};
